<script>
  import { onDestroy } from 'svelte';
  // noinspection ES6UnusedImports
  import { fade } from 'svelte/transition';
  import { deleteComment, listenToChatPreview, publishComment } from '../../../Api/api';
  import { getTime } from '../../../common/dates';
  import { containsLink, setLink } from '../../../common/utils.js';
  import { firebaseApp } from '../../../Store/store';

  export let channelId = '';

  let unsubscribeListenToChat;
  let unsubscribeListenToChannel;
  let thread = [];

  let currentId = '';

  $: channelId && listenToNewChatData(channelId);

  onDestroy(async () => {
    if (unsubscribeListenToChat) {
      unsubscribeListenToChat();
    }
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
    }
  });

  const onPublishCommentClicked = async (comment) => {
    // Get timestamp when moderator publishes the message to show last in the chat
    const updatedComment = {
      ...comment,
      ignore: false,
      created: $firebaseApp.serverTimestamp,
    };
    await publishComment(currentId, updatedComment);
  };

  const onDeleteCommentClicked = async (comment) => {
    await deleteComment(currentId, comment.commentId);
  };

  const listenToNewChatData = async (channelId) => {
    if (channelId !== currentId) {
      if (unsubscribeListenToChat) {
        unsubscribeListenToChat();
        unsubscribeListenToChat = null;
      }
      currentId = channelId;
      unsubscribeListenToChat = await listenToChatPreview(channelId, (snapShot) => {
        console.log('Update chat messages', new Date().getTime());
        const chatData = [];
        snapShot.forEach((doc) => {
          const data = doc.data();
          const item = { ...data, commentId: doc.id };
          if (data.sticky) {
            // push to front
            chatData.unshift(item);
          } else {
            // push to end
            chatData.push(item);
          }
        });
        thread = chatData.filter((c) => !c.a && !c.blocked && !c.d && !c.m);
      });
    }
  };

  let stickyFilter = false;
  const onApplyStickyFilter = () => {
    stickyFilter = !stickyFilter;
  };
</script>

<div class="moderator-container">
  <div class="header">
    <button class="btn sticky-filter-btn" class:on={stickyFilter} on:click={onApplyStickyFilter}
      ><span class="material-icons" class:sticky={stickyFilter}>verified</span>
    </button>
    <span class="info">{stickyFilter ? 'Meldingsfilter på' : 'Meldingsfilter av'}</span>
  </div>
  <div class="comments">
    {#if thread.length}
      {#each thread.filter((c) => !stickyFilter || c.sticky) as comment (comment.commentId)}
        <div class="comment" in:fade>
          <div class="main">
            <div class="time-user">
              <span class="time-stamp">{getTime(comment.created.toDate())}</span>
              <span class="user-name">{comment.userName}</span>
              {#if comment.sticky}
                <span class="material-icons star">verified</span>
              {/if}
            </div>
            <div class="content">
              {#if containsLink(comment.content)}
                {@html setLink(comment.content)}
              {:else}{comment.content}{/if}
            </div>
          </div>
          <div class="controls">
            <button class="btn delete" on:click={() => onDeleteCommentClicked(comment)}
              ><span class="material-icons"> block </span></button
            >
            <button class="btn ok" on:click={() => onPublishCommentClicked(comment)}
              ><span class="material-icons"> done </span></button
            >
          </div>
        </div>
      {/each}
    {:else}
      <div class="no-msg" in:fade>
        <p>Ingen meldinger</p>
      </div>
    {/if}
  </div>
</div>

<style src="./compactModerator.scss">
</style>
